export default __webpack_public_path__ + "static/media/banco-itau.3e475f7e.svg";